import { useMemo } from 'react';
import { LocationCountryCode, SettingName } from 'src/api/generated';
import { useStringSetting } from 'src/hooks/settings/settings';

const supportedCountryCodes = new Set<string>(
  Object.values(LocationCountryCode)
);

/**
 * Resolves the current tenant country code from settings.
 */
export const useTenantCountryCode = (): LocationCountryCode | null => {
  const { setting, loading } = useStringSetting(SettingName.COUNTRY);

  return useMemo<LocationCountryCode | null>(() => {
    if (loading || !setting) {
      return null;
    }

    const normalizedCountryCode = setting.trim().toUpperCase();

    if (!supportedCountryCodes.has(normalizedCountryCode)) {
      return null;
    }

    return normalizedCountryCode as LocationCountryCode;
  }, [loading, setting]);
};
